module.exports = __webpack_public_path__ + "static/media/02.87c6eb21.png";